





























import Vue from "vue";
import Component from "vue-class-component";
import routerService from '../base/router-service';
import empresaAtualService from '../features/empresa-atual/empresa-atual-service';
import areaService from '../features/area-atual/area-service';

@Component
export default class TabsEmpresaFuncionarios extends Vue {
    empresaAtual: string = null;

    areaAtual: string = null;

    aba: number = 0;

    async carregar() {
        this.areaAtual = await areaService.obterAreaPadrao();
        this.empresaAtual = await empresaAtualService.obterEmpresaAtualId();
    }

    created() {
        this.carregar();
    }

    async editarEmpresa(empresaId: number) {
        await routerService.goTo('empresa-editar', { empresaId });
    }
}
